import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get } from '../services/crud'
import { LeadSummary } from './typings'
import {
  pageToSearchInput,
  searchInputToQueryString,
  ISearchResponse,
} from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.lead.lead}${ServiceConfig.lead.location}`

export const getLocationLeads = createAsyncThunk<
  ISearchResponse<LeadSummary>,
  { externalLinkId: string; page: number; perPage: number }
>('leadSummary/location', async ({ externalLinkId, page, perPage }) => {
  const qstring = searchInputToQueryString(pageToSearchInput(page, perPage))
  const response = await get(`${baseUrl}/${externalLinkId}?${qstring}`)
  if (response.ok) return await response.json()
})
